const CheckboxStyles = {
  // Can simply pass default props to change default behaviour of components.
  defaultProps: {
    variant: "primary",
    _disabled: {
      _text: {
        color: "neutrals.850",
      },
    },
  },
  baseStyle: ({ colorScheme }: { colorScheme: string }) => {
    return {
      _checkbox: {
        bg: "transparent",
      },
      _checked: {
        bg: `${colorScheme}.300`,
        borderColor: `${colorScheme}.300`,
        borderWidth: 2,
      },
      __unchecked: {
        borderWidth: 2,
      },
      _icon: {
        color:
          colorScheme === "primary" ? `${colorScheme}.900` : "neutrals.850",
      },
    };
  },
  sizes: {
    lg: { padding: 0.5, _icon: { size: 6 }, _text: { fontSize: "xl" } },
    md: { padding: 0.5, _icon: { size: 5 }, _text: { fontSize: "lg" } },
    sm: { padding: 0.5, _icon: { size: 3 }, _text: { fontSize: "md" } },
  },
};

export default CheckboxStyles;
